var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChevron(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 19,
    viewBox: "0 0 11 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.10781 18.5036L0.788556 10.1997C0.694973 10.1062 0.628956 10.0074 0.590506 9.90358C0.55204 9.79975 0.532806 9.68758 0.532806 9.56706C0.532806 9.44654 0.55204 9.33437 0.590506 9.23053C0.628956 9.12668 0.694981 9.02797 0.788581 8.93438L9.11741 0.605534C9.30587 0.417067 9.53664 0.322834 9.80971 0.322834C10.0828 0.322834 10.3219 0.4254 10.527 0.630534C10.7257 0.82925 10.8251 1.06322 10.8251 1.33243C10.8251 1.60167 10.7257 1.83564 10.527 2.03436L2.99431 9.56706L10.5366 17.1094C10.7251 17.2978 10.8193 17.526 10.8193 17.794C10.8193 18.0619 10.7167 18.2985 10.5116 18.5036C10.3129 18.7023 10.0789 18.8017 9.80971 18.8017C9.54047 18.8017 9.30651 18.7023 9.10781 18.5036Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevron);
export default __webpack_public_path__ + "static/media/chevron.bd0c7d2886bbb7c7f27bc509d4ff5ff3.svg";
export { ForwardRef as ReactComponent };